import { AmqMoveMessageI } from "./amq-move-message.int";
import { OrdEquipmentResultExtI } from "./ord-equipment.result.ext";

export const ActiveMqMap = {

  mapEquipmentResult: (ext: OrdEquipmentResultExtI): AmqMoveMessageI => {
    return {
      event: ext.event,
      equipmentCode: ext.header.equipmentId,
      depotCode: ext.header.terminalId,
      location: ActiveMqMap.mapBlock(ext.location.yardLocation.block) ? `${ext.location.yardLocation.block}${ext.location.yardLocation.bay}${ext.location.yardLocation.row}${ext.location.yardLocation.tier}` : null,
    }
  },
  mapBlock: (block: string | number): null | string => {
    // Locatie in block 0 ook beschouwen als 'lege' locatie, zodat het opzetten/afzetten bij een truck niet beschouwd wordt als locatie in de stack.
    if (block === undefined || block === null || block === '' || block === '0' || block === 0) {
      return null;
    }
    return block as string;
  },
};
